import { Component, OnInit, Input, forwardRef, NgModule } from '@angular/core';
import { NG_VALUE_ACCESSOR, FormsModule } from '@angular/forms';
import { CommonModule } from '@angular/common';
import { ApiService } from '../services/api.service';
import { AutoCompleteModule } from '../share/primeng/autocomplete/autocomplete';

export const /** @type {?} */ CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR: any = {
    provide: NG_VALUE_ACCESSOR,
    useExisting: forwardRef(() => PickAddrComponent),
    multi: true
};
export class PickAddrComponent implements OnInit {
/**
 * 数据
 */
suggestions: any[];
    
    _userCode = "";

    
    defaultLabel: string = "请选择…";
    
    multiSelect: boolean = false;
    
    valueField: string = "";
    
    styleClass: string;
/**
 * @param {?} code
 * @return {?}
 */
set userCode(code: any) {
        if(this._userCode !== code) {
            this._userCode = code;
            this.queryData(null);
        }
    }
public onTouchedCallback: () => () => {};
public onChangeCallback: (_: any) => () => {};
public innerValue;
/**
 * @return {?}
 */
get value(): any {
        return this.innerValue;
    };
/**
 * @param {?} v
 * @return {?}
 */
set value(v: any) {
        let /** @type {?} */ vv = v && v.detailed ? v.detailed : v;
        this.innerValue = vv;
        if (this.valueField === 'object') {
            // let _value=v[this.valueField]?v[this.valueField]:v;
            this.onChangeCallback(v);
        } else {
            this.onChangeCallback(vv);
        }
    }
/**
 * @param {?} api
 */
constructor(public api: ApiService) {
    }
/**
 * @return {?}
 */
ngOnInit() {
        this.suggestions = [];
    }
/**
 * @param {?} value
 * @return {?}
 */
writeValue(value: any) {
        if (value !== this.innerValue) {
            this.innerValue = value;
        }
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnChange(fn: any) {
        this.onChangeCallback = fn;
    }
/**
 * @param {?} fn
 * @return {?}
 */
registerOnTouched(fn: any) {
        this.onTouchedCallback = fn;
    }
/**
 * 查询数据
 * @param {?} $event
 * @return {?}
 */
queryData($event: any) {
        // let value = $event.query;
        this.api.getPickAddr([{
            name: this._userCode
        }]).subscribe(json => {
            let /** @type {?} */ result: any = json.result && json.result.content || [];
            this.suggestions = result || [];
        });
    }

static decorators: DecoratorInvocation[] = [
{ type: Component, args: [{
    selector: 'pick-addr',
    template: `
    <p-autoComplete
        name="pickAddr"
        [(ngModel)]="value" 
        [placeholder]='defaultLabel'
        [suggestions]="suggestions" 
        field="name" 
        [style]="{'width':'100%'}">
        <ng-template let-brand pTemplate="item">
            <div class="ant-select-dropdown-menu-item">
                {{brand.name}}
            </div>
        </ng-template>
    </p-autoComplete>
    `,
    styles: [`
     :host ::ng-deep .ui-autocomplete-panel {
         background: #fff;
     }
    `],
    providers: [CUSTOM_INPUT_CONTROL_VALUE_ACCESSOR]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
{type: ApiService, },
];
static propDecorators: {[key: string]: DecoratorInvocation[]} = {
'defaultLabel': [{ type: Input },],
'multiSelect': [{ type: Input },],
'valueField': [{ type: Input },],
'styleClass': [{ type: Input },],
'userCode': [{ type: Input },],
};
}

function PickAddrComponent_tsickle_Closure_declarations() {
/** @type {?} */
PickAddrComponent.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PickAddrComponent.ctorParameters;
/** @type {?} */
PickAddrComponent.propDecorators;
/**
 * 数据
 * @type {?}
 */
PickAddrComponent.prototype.suggestions;
/** @type {?} */
PickAddrComponent.prototype._userCode;
/** @type {?} */
PickAddrComponent.prototype.defaultLabel;
/** @type {?} */
PickAddrComponent.prototype.multiSelect;
/** @type {?} */
PickAddrComponent.prototype.valueField;
/** @type {?} */
PickAddrComponent.prototype.styleClass;
/** @type {?} */
PickAddrComponent.prototype.onTouchedCallback;
/** @type {?} */
PickAddrComponent.prototype.onChangeCallback;
/** @type {?} */
PickAddrComponent.prototype.innerValue;
/** @type {?} */
PickAddrComponent.prototype.api;
}

export class PickAddrModule { static decorators: DecoratorInvocation[] = [
{ type: NgModule, args: [{
    declarations: [
        PickAddrComponent
    ],
    exports: [PickAddrComponent],
    imports: [
        CommonModule,
        FormsModule,
        AutoCompleteModule
    ]
}, ] },
];
/**
 * @nocollapse
 */
static ctorParameters: () => ({type: any, decorators?: DecoratorInvocation[]}|null)[] = () => [
];
}

function PickAddrModule_tsickle_Closure_declarations() {
/** @type {?} */
PickAddrModule.decorators;
/**
 * @nocollapse
 * @type {?}
 */
PickAddrModule.ctorParameters;
}


interface DecoratorInvocation {
  type: Function;
  args?: any[];
}
